import api from "../../services/api";
import toastUtils from "../../utils/toastUtils";

const useDashboard = () => {
  const find = async (params) => {
    try {
      console.log('Buscando dados do dashboard com params:', params);
      
      const { data } = await api.request({
        url: `/dashboard`,
        method: 'GET',
        params
      });

      console.log('Dados recebidos do dashboard:', data);

      // Validar estrutura dos dados
      if (!data) {
        throw new Error('Nenhum dado retornado do servidor');
      }

      // Garantir que counters existe e tem valores padrão
      const defaultCounters = {
        avgSupportTime: 0,
        avgWaitTime: 0,
        supportFinished: 0,
        supportHappening: 0,
        supportPending: 0,
        supportGroups: 0,
        leads: 0,
        activeTickets: 0,
        passiveTickets: 0,
        tickets: 0,
        waitRating: 0,
        withoutRating: 0,
        withRating: 0,
        percRating: 0,
        npsPromotersPerc: 0,
        npsPassivePerc: 0,
        npsDetractorsPerc: 0,
        npsScore: 0,
        firstContactResolution: 0,
        avgFirstResponseTime: 0,
        abandonmentRate: 0,
        reopenRate: 0,
        ticketsByChannel: {}
      };

      const responseData = {
        counters: { ...defaultCounters, ...data.counters },
        attendants: Array.isArray(data.attendants) ? data.attendants : []
      };

      console.log('Dados processados do dashboard:', responseData);

      return responseData;
    } catch (error) {
      console.error('Erro ao buscar dados do dashboard:', error);
      
      // Verificar se é um erro de permissão ou recurso não disponível
      if (error?.response?.status === 403) {
        console.warn('Acesso negado ao dashboard - recurso pode não estar disponível no plano atual');
        // Não mostrar toast para erros 403, pois são esperados quando recursos não estão ativos
      } else if (error?.response?.status === 500) {
        console.warn('Erro interno do servidor no dashboard');
        // Não mostrar toast para erros 500, pois são tratados pelo backend
      } else if (error?.response?.data?.message) {
        toastUtils.error(error.response.data.message, "Erro nos Dados");
      } else {
        toastUtils.error('Erro ao carregar dados do dashboard', 'Erro nos Dados');
      }
      
      // Retornar dados vazios em caso de erro
      return {
        counters: {
          avgSupportTime: 0,
          avgWaitTime: 0,
          supportFinished: 0,
          supportHappening: 0,
          supportPending: 0,
          supportGroups: 0,
          leads: 0,
          activeTickets: 0,
          passiveTickets: 0,
          tickets: 0,
          waitRating: 0,
          withoutRating: 0,
          withRating: 0,
          percRating: 0,
          npsPromotersPerc: 0,
          npsPassivePerc: 0,
          npsDetractorsPerc: 0,
          npsScore: 0,
          firstContactResolution: 0,
          avgFirstResponseTime: 0,
          abandonmentRate: 0,
          reopenRate: 0,
          ticketsByChannel: {}
        },
        attendants: []
      };
    }
  };

  const getTimeline = async (params) => {
    try {
      console.log('Buscando timeline com params:', params);

      const { data } = await api.request({
        url: `/dashboard/ticketsTimeline`,
        method: 'GET',
        params
      });

      console.log('Dados da timeline recebidos:', data);
      return data;
    } catch (error) {
      console.error('Erro ao buscar timeline:', error);

      // Verificar se é um erro de permissão ou recurso não disponível
      if (error?.response?.status === 403) {
        console.warn('Acesso negado à timeline - recurso pode não estar disponível no plano atual');
        // Não mostrar toast para erros 403
      } else if (error?.response?.status === 500) {
        console.warn('Erro interno do servidor na timeline');
        // Não mostrar toast para erros 500
      } else if (error?.response?.data?.message) {
        toastUtils.error(error.response.data.message, "Erro nos Dados");
      } else {
        toastUtils.error('Erro ao carregar timeline', 'Erro nos Dados');
      }

      return { data: [] };
    }
  };

  const getReport = async (params) => {
    try {
      console.log('Buscando relatório com params:', params);

      const { data } = await api.get(`/ticketreport/reports`, { params });

      console.log('Dados do relatório recebidos:', data);
      return data;
    } catch (error) {
      console.error('Erro ao buscar relatório:', error);

      if (error?.response?.status === 403) {
        console.warn('Acesso negado ao relatório - recurso pode não estar disponível no plano atual');
      } else if (error?.response?.status === 500) {
        console.warn('Erro interno do servidor no relatório');
      } else if (error?.response?.data?.message) {
        toastUtils.error(error.response.data.message, "Erro nos Dados");
      } else {
        toastUtils.error('Erro ao carregar relatório', 'Erro nos Dados');
      }

      return { tickets: [], totalTickets: { total: 0 } };
    }
  };

  return {
    find,
    getReport,
    getTimeline
  };
};

export default useDashboard;